module.exports = __webpack_public_path__ + "img/step4.a46fabb7.png";